import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-bg-items-white heading-s-bold mt-12 flex h-12.5 w-full cursor-pointer items-center justify-center uppercase',
    loading: 'loading absolute opacity-0 transition-opacity',
    loadMoreButtonText: 'transition-opacity'
  },
  variants: {
    isLoading: {
      true: {
        base: 'cursor-default',
        loading: 'opacity-100',
        loadMoreButtonText: 'opacity-0'
      }
    }
  }
});
